// IMPORT PACKAGE REFERENCES
import React from 'react';

// IMPORT PROJECT REFERENCES

import { PharmacyBrowser } from '../../DeviceBrowser/PharmacyBrowser';


// COMPONENT

export const PharmacyListPage = () => (
    <div className="animated fadeIn">
        <PharmacyBrowser />
    </div>
);